import template from './attachmentEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, eventService, uiService, Document) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.CurrentAccount = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentAccount = $rootScope.CurrentAccount;
        ctrl.destroyWatch = eventService.onAttachmentEdit((params) => {
          ctrl.attachments = [];
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                url: params.url,
                title: params.title,
                allowedMimeTypes: params.allowedMimeTypes,
                allowedExtensions: params.allowedExtensions,
                ticketId: params.ticketId,
                types: params.types && params.types.length ? params.types : [],
                isCompliance: params.isCompliance ? params.isCompliance : false
              },
              template,
              controllerAs: '$ctrl',
              controller(
                scope,
                url,
                title,
                allowedMimeTypes,
                allowedExtensions,
                ticketId,
                types,
                isCompliance
              ) {
                const ctr = this;
                ctr.files = [];
                ctr.url = url;
                ctr.title = title;
                ctr.allowedMimeTypes = allowedMimeTypes;
                ctr.allowedExtensions = allowedExtensions;
                ctr.startUpload = false;
                ctr.ticketId = ticketId;
                ctr.types = types;
                ctr.isCompliance = isCompliance;

                ctr.uploadFinished = (attachments) => {
                  $mdDialog.hide({
                    attachments,
                    types: ctr.types,
                    isCompliance: ctr.isCompliance
                  });
                };
                ctr.confirm = () => {
                  if (scope.attachmentEdit.files.$viewValue.length) {
                    ctr.startUpload = true;
                    ctr.files = scope.attachmentEdit.files.$viewValue;
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Attachment',
                        p2: 'is not of',
                        p3: 'correct type'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((files) => {
              const len = files.attachments.length;
              for (let i = 0; i < len; i += 1) {
                const attachment = Document.blank();
                attachment.idOwner = ctrl.CurrentAccount.id;
                attachment.name = files.attachments[i].name;
                attachment.file = files.attachments[i].file;
                attachment.types = files.types;
                attachment.isCompliance = files.isCompliance;
                attachment.isNew = true;
                ctrl.attachments.push(attachment);
              }
              ctrl.onFinished({
                attachments: ctrl.attachments,
                isCompliance: files.isCompliance
              });
              uiService.toast({
                text: {
                  p1: files.length > 1 ? ctrl.attachments.length : 'Attachment',
                  p2: files.length > 1 ? 'attachments' : ctrl.attachments[0].getName(),
                  p3: `${files.length > 1 ? 'have' : 'has'} been added`
                }
              });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
